import { z } from "zod";

export interface Firm {
  firm_id: string;
  name: string;
  has_active_subscription?: boolean;
  settings?: Record<string, unknown>;
}

export type FirmSettingsValue =
  | string
  | number
  | boolean
  | null
  | FirmSettingsValue[]
  | { [key: string]: FirmSettingsValue };

const FirmSettingsValueSchema: z.ZodType<FirmSettingsValue> = z.lazy(() =>
  z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(FirmSettingsValueSchema),
    z.record(z.string(), FirmSettingsValueSchema),
  ])
);

export const FirmSettingsResponseSchema = z.object({
  name: z.string(),
  settings: z.record(z.string(), FirmSettingsValueSchema),
});

export type FirmSettingsResponse = z.infer<typeof FirmSettingsResponseSchema>;

export interface UpdateFirmSettingsRequest {
  name?: string;
  settings?: Record<string, FirmSettingsValue>;
}
